import { render, staticRenderFns } from "./PriceMonitoringTable.vue?vue&type=template&id=2c299b15"
import script from "./PriceMonitoringTable.vue?vue&type=script&lang=js"
export * from "./PriceMonitoringTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports